import { render, staticRenderFns } from "./ToolbarLogo.vue?vue&type=template&id=b420520c&scoped=true&"
var script = {}
import style0 from "./ToolbarLogo.vue?vue&type=style&index=0&id=b420520c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b420520c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileSubTitle } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
installComponents(component, {
  VListTile,
  VListTileContent,
  VListTileSubTitle,
  VListTileTitle,
})
